// src/pages/SettingsPage.js
import React, {useEffect, useState} from 'react';
import GeneralSettings from "../../components/settings/GeneralSettings";
import LoyaltyProgramSettings from "../../components/settings/LoyaltyProgramSettings";
import IntegrationsSettings from "../../components/settings/IntegrationsSettings";
import UsersSettings from "../../components/settings/UserSettings";
import BillingSettings from "../../components/settings/BillingSettings";
import SecuritySettings from "../../components/settings/SecuritySettings";
import DashboardLayout from "../../components/test/DashboardLayout";
import SettingsSidebar from "../../components/settings/SettingsSidebar";
import {useParams} from "react-router-dom";
import {onValue, ref} from "firebase/database";
import {db} from "../../firebase";


const SettingsPage = () => {
    const {userId, businessId} = useParams();

    const [activeSection, setActiveSection] = useState('general'); // Default active section
    const [businessProfile, setBusinessProfile] = useState({});
    const [users, setUsers] = useState([]);

    useEffect(() => {
        onValue(ref(db, `localRewards/businessProfile/${userId}`), snapshot => {
            if (snapshot.exists()) {
                const businessProfile = snapshot.val();
                setBusinessProfile({ ...businessProfile })
            }
        })
        onValue(ref(db, `localRewards/users/${userId}`), snapshot => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                if (data) {
                    Object.values(data).map((item) => {
                        setUsers((oldArray) => [...oldArray, item])
                    })
                }
            }
        })
    }, [userId])

    const renderContent = () => {
        switch (activeSection) {
            case 'general':
                return <GeneralSettings businessProfile={businessProfile} userId={userId} />;
            case 'loyaltyProgram':
                return <LoyaltyProgramSettings />;
            case 'integrations':
                return <IntegrationsSettings />;
            case 'users':
                return <UsersSettings users={users} />;
            case 'billing':
                return <BillingSettings />;
            // case 'security':
            //     return <SecuritySettings />;
            default:
                return <GeneralSettings />;
        }
    };

    return (
        <DashboardLayout userId={userId} businessId={businessId}>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Settings</h1>

            <div className="flex flex-col lg:flex-row gap-6">
                {/* Sidebar */}
                <div className="lg:w-1/4">
                    <SettingsSidebar activeSection={activeSection} setActiveSection={setActiveSection} />
                </div>

                {/* Content Area */}
                <div className="flex-1 bg-white rounded-lg shadow-md p-6 lg:min-h-[70vh]">
                    {renderContent()}
                </div>
            </div>
        </DashboardLayout>
    );
};

export default SettingsPage;